export const lifeWheelOrientationOrder = ["Achievement", "Relationship", "Leadership", "Learning", "Nurturing"];


// WEBPACK FOOTER //
// ./src/new/Utils/orientation.js